import { Tab } from '@headlessui/react'
import classNames from 'classnames'
import { CustomTab } from '../Tab'
import React from 'react'

interface TabGroupInterface {
  tabNumber?: number
  error?: Record<string, any>
  children?: React.ReactNode
  showTabNumberIcon?: boolean
  selectColorText?: string
  selectedColorBackground?: string
  selectedColorBorder?: string
  tabConfiguration: any
  pannelConfiguration: any
  initialTab?: string
  selectedIndex?: number
  setSelectedIndex?: (tab: number) => void
}

export const TabGroup = ({
  tabNumber,
  error,
  children,
  showTabNumberIcon,
  selectColorText,
  selectedColorBackground,
  selectedColorBorder,
  tabConfiguration,
  pannelConfiguration,
  initialTab,
  selectedIndex,
  setSelectedIndex
}: TabGroupInterface) => {
  const defaultIndex = initialTab
    ? tabConfiguration.findIndex(
        (config: Record<string, any>) => config.name === initialTab
      )
    : 0

  return (
    <Tab.Group
      defaultIndex={defaultIndex}
      selectedIndex={selectedIndex}
      onChange={setSelectedIndex}
    >
      <Tab.List className={classNames('flex p-5')}>
        {tabConfiguration.map((item: any, index: number) => {
          return (
            <div key={`item.name-${index}`}>
              <CustomTab
                tabNumber={tabNumber}
                title={item.name}
                error={error}
                children={children}
                showTabNumberIcon={showTabNumberIcon}
                selectedColorBackground={selectedColorBackground}
                selectColorText={selectColorText}
                selectedColorBorder={selectedColorBorder}
                onClick={item.onClick}
              />
            </div>
          )
        })}
      </Tab.List>
      <Tab.Panels>
        {pannelConfiguration.map((item: any, index: number) => {
          return (
            <div key={`item.name-${index}`}>
              <Tab.Panel>{item.component}</Tab.Panel>
            </div>
          )
        })}
      </Tab.Panels>
    </Tab.Group>
  )
}
